import { connect } from 'react-redux';
import TwoColumnsContentParticipantCell from './TwoColumnsContentParticipantCell'

export default connect(
  ({participant}) => ({
    participants: participant.list.map(id => participant.items[id])
  })
)(TwoColumnsContentParticipantCell);



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/TwoColumnContent/TwoColumnsContentParticipantCell/index.js